import { theme2022 } from 'gocclr-shared-ui/dist/styles/theme-2022';
import { DefaultTheme } from 'styled-components'

export const gocclDefaultTheme: DefaultTheme = {
    colors: {
        primary: {
            black: '',
            blue: '#10549b',
            red: '#d0021b',
            white: '#fff'
        },
        background: {
            white: '#fff',
            offWhite: '#c7c7c7'
        },
        text: {
            primary: '#575757',
            lightGrey: '',
            white: '#fff',
            blue: '#10549b',
            green: '#2fa254',
            red: '#d0021b'
        },
        cta: {
            disable: '#bbb',
            blue: {
                base: '#10549b'
            },
            green: {
                base: '#2fa254'
            },
            red: {
                base: '#d0021b'
            }
        },
        outline: {
            blue: '#10549b',
            grey: '#979797'
        },
        dividers: {
            grey: '#c7c7c7',
            white: '#fff'
        },
        focusState: '#009eb3',
        errorState: '#d0021b',
        alert: {
            low: '#009ed9',
            medium: '#f5a623',
            high: '#d0021b',
            success: '#2fa254'
        },
        rawColors: {
            transparent: 'transparent',
            'color-1': '#fff', // in-use (Seen as text & BG)
            'color-2': '#10549b', // in-use (Seen as text & BTN)
            'color-3': '#575757', // in-use (Seen as Default Text)
            'color-4': '#d9f3ff', // in-use (Seen as FAC_BTN)
            'color-5': '#c7c7c7', // in-use (Seen as BG & Table Column Dividers)
            'color-6': '#979797', // in-use (Seen as outline)
            'color-7': '#f7f7f7', // in-use: (Seen as Section_BG)
            'color-8': '#bbb', // in-use: (Seen as Disabled_Item, BTN_Border, Placeholder)
            'color-9': '#f5a623', // in-use: (Seen as Warning_Advisory)
            'color-10': '#d0021b', // in-use: Seen as BTN, Error, Error_Advisory
            'color-11': '#009ed9', // in-use (Seen as Default_Advisory)
            'color-12': '#b1d2eb', // in-use: (Seen as Divider line on RateCode)
            'color-13': '#2fa254', // in-use: (Seen in bookingSteps circles)
            'color-14': 'rgba(0, 0, 0, 0.4)', // in-use: Modal Overlay
        }
    }
};

export const goccl2022Theme: DefaultTheme = {
    colors: {
        primary: {
            black: theme2022.colors.black,
            blue: theme2022.colors.blue,
            red: theme2022.colors.red,
            white: theme2022.colors.white
        },
        background: {
            white: theme2022.colors.white,
            offWhite: theme2022.colors['off-white']
        },
        text: {
            primary: theme2022.colors.grey,
            lightGrey: theme2022.colors['light-grey'],
            white: theme2022.colors.white,
            blue: theme2022.colors.blue,
            green: theme2022.colors.green,
            red: theme2022.colors.red
        },
        cta: {
            disable: theme2022.colors['cta-blue-disabled'],
            blue: {
                base: theme2022.colors['cta-blue'],
                hover: theme2022.colors['cta-blue-hover'],
                pressed: theme2022.colors['cta-blue-pressed'],
                disabled: theme2022.colors['cta-blue-disabled'],
            },
            green: {
                base: theme2022.colors['cta-red'],
                hover: theme2022.colors['cta-red-hover'],
                pressed: theme2022.colors['cta-red-pressed'],
                disabled: theme2022.colors['cta-red-disabled'],
            },
            red: {
                base: theme2022.colors['cta-green'],
                hover: theme2022.colors['cta-green-hover'],
                pressed: theme2022.colors['cta-green-pressed'],
                disabled: theme2022.colors['cta-green-disabled'],
            }
        },
        outline: {
            blue: theme2022.colors['outline-blue'],
            grey: theme2022.colors['outline-grey']
        },
        dividers: {
            grey: theme2022.colors['divider-grey'],
            white: theme2022.colors.white
        },
        focusState: theme2022.colors['focus-state'],
        errorState: theme2022.colors['error-state'],
        alert: {
            low: '#009ed9',
            medium: '#f5a623',
            high: theme2022.colors.red,
            success: theme2022.colors.green
        },
        rawColors: theme2022.colors
    }
};